<template>
    <!-- Aggiunto overflow: hidden e rimosso il padding-bottom per impedire al 100% di sbordare -->
    <div style="height: 100%; display: flex; flex-direction: column; overflow: hidden; box-sizing: border-box">
        <!-- HEADER / TOOLBAR -->
        <div class="sa-utility-section d-flex justify-content-end align-items-center mb-3 pb-2" style="border-bottom: 1px solid #dee2e6; flex-shrink: 0">
            <!-- NUOVA CHECKBOX (Switch) -->
            <div class="d-flex align-items-center mr-4">
                <b-form-checkbox v-model="mostraConcluse" switch size="sm" class="mb-0 text-muted font-weight-bold" style="cursor: pointer"> Mostra concluse </b-form-checkbox>
            </div>

            <div class="d-flex align-items-center ft-gap-8-px">
                <b-button size="sm" variant="outline-success" @click="onClickNuovaPrescrizioneEsercizi()"> <i class="fas fa-plus"></i> Nuova Prescrizione </b-button>
            </div>
        </div>

        <!-- CONTENT -->
        <!-- Il padding-bottom spostato qui assicura che ci sia sempre spazio sotto l'ultima card -->
        <div style="flex-grow: 1; overflow-y: auto; overflow-x: hidden; padding-right: 5px; padding-bottom: 40px; min-height: 0">
            <!-- VISTA RAGGRUPPATA PER PRESCRIZIONE -->
            <template v-if="prescrizioniList.length > 0">
                <div v-for="(prescrizione, indexPresc) in prescrizioniList" :key="prescrizione.id || indexPresc" class="mb-4">
                    <!-- HEADER PRESCRIZIONE (Azioni di Modifica, Stampa e Conclusione) -->
                    <div class="sa-prescrizione-header mb-3 d-flex justify-content-between align-items-center">
                        <div class="d-flex align-items-center flex-grow-1" v-b-toggle="'collapse-prescrizione-' + indexPresc" style="cursor: pointer">
                            <i class="fas fa-folder-open" style="color: var(--bg-sidebar); font-size: 18px"></i>
                            <span class="sa-articolo-section-title ml-2 mr-3">{{ prescrizione.nome }}</span>

                            <!-- Dettagli base prescrizione -->
                            <span class="text-muted small mr-3"><i class="far fa-calendar-alt"></i> Inizio: {{ formatDate(prescrizione.dataInizio) }}</span>
                            <span class="sa-ft-badge" :class="getClass('stato', prescrizione.statoAttuale)">{{ prescrizione.statoAttuale }}</span>

                            <i class="fas fa-chevron-down sa-ft-icona-collapse ml-auto mr-3"></i>
                        </div>

                        <!-- Pulsanti di azione sulla PRESCRIZIONE -->
                        <div class="d-flex ft-gap-8-px" @click.stop>
                            <div class="sa-print-button-wrapper">
                                <print-component :linkPrintData="getLinkPrintPrescrizione(prescrizione.datiOriginali)" :typeButton="'small'" :nomeFile="'prescrizione_esercizi'" />
                            </div>
                            <b-button v-b-tooltip.hover size="sm" variant="outline-primary" title="Modifica Prescrizione" @click="onClickEditPrescrizioneEsercizi(prescrizione.datiOriginali)" class="rounded-circle sa-ft-floating-btn primary">
                                <b-icon icon="pencil"></b-icon>
                            </b-button>

                            <!-- BOTTONE: Concludi Prescrizione (Visibile solo se non è già conclusa) -->
                            <b-button v-if="prescrizione.statoAttuale !== 'CONCLUSA'" size="sm" v-b-tooltip.hover title="Concludi Prescrizione" variant="outline-success" @click="concludiPrescrizione(prescrizione.datiOriginali)" class="rounded-circle sa-ft-floating-btn danger">
                                <i class="fas fa-times"></i>
                            </b-button>
                        </div>
                    </div>

                    <!-- LISTA ESERCIZI PER QUESTA PRESCRIZIONE -->
                    <b-collapse :id="'collapse-prescrizione-' + indexPresc" visible>
                        <div class="sa-card-list pl-4 ml-2 border-left" style="border-color: #dee2e6 !important">
                            <div v-if="prescrizione.esercizi.length === 0" class="text-muted small py-2">Nessun esercizio presente in questa prescrizione.</div>

                            <div v-for="(item, indexEs) in prescrizione.esercizi" :key="item.primaryKey || indexEs" class="sa-ft-modern-card mb-2">
                                <b-row align-v="center" class="m-0 py-3">
                                    <!-- NOME ESERCIZIO -->
                                    <b-col cols="12" md="4" class="mb-2 mb-md-0">
                                        <div class="sa-ft-valore-pai primary-text">
                                            <span v-html="getTestoHtmlNomeAttivita(item)"></span>
                                        </div>
                                    </b-col>

                                    <!-- INDICAZIONI -->
                                    <b-col cols="12" md="3" class="mb-2 mb-md-0">
                                        <div class="sa-ft-label-pai">INDICAZIONI</div>
                                        <div class="sa-ft-valore-pai text-muted small text-break" style="max-height: 60px; overflow-y: auto">
                                            <div v-html="item.note || '-'"></div>
                                        </div>
                                    </b-col>
                                    <b-col cols="12" md="3" class="mb-2 mb-md-0">
                                        <div class="sa-ft-label-pai">PROGRAMMAZIONE</div>
                                        <div class="sa-ft-valore-pai text-muted small">{{ item.programmazione }}</div>
                                    </b-col>
                                    <b-col cols="12" md="2" class="text-right mt-3 mt-md-0 d-flex justify-content-md-end align-items-center ft-gap-8-px">
                                        <b-button v-b-tooltip.hover size="sm" variant="outline-info" title="Storico Esecuzioni" @click="onClickVisualizzaEsecuzioni(item)" class="rounded-circle sa-ft-floating-btn info" style="border: 1px solid #17a2b8 !important">
                                            <i class="fas fa-history"></i>
                                        </b-button>
                                        <b-button v-if="prescrizione.statoAttuale !== 'CONCLUSA'" v-b-tooltip.hover size="sm" variant="outline-success" title="Esegui Esercizio" @click="onClickEseguiEsercizio(item, prescrizione)" class="rounded-circle sa-ft-floating-btn success">
                                            <i class="fas fa-play"></i>
                                        </b-button>

                                        <b-button v-b-tooltip.hover size="sm" :title="item.showVideo ? 'Chiudi Video' : 'Visualizza Video'" @click="onClickVisualizzaVideo(item)" class="rounded-circle sa-ft-floating-btn sa-video-btn" :class="{ 'video-open': item.showVideo }">
                                            <i class="fas" :class="item.showVideo ? 'fa-video-slash' : 'fa-video'"></i>
                                        </b-button>
                                    </b-col>
                                </b-row>

                                <!-- BOX RIPRODUZIONE VIDEO SOTTO L'ESERCIZIO -->
                                <b-collapse :id="'collapse-video-' + indexPresc + '-' + indexEs" v-model="item.showVideo">
                                    <div class="sa-video-container border-top">
                                        <div v-if="item.caricamentoVideo" key="loading" class="text-center py-4 text-muted"><b-spinner small class="mr-2"></b-spinner> <span>Caricamento video in corso...</span></div>
                                        <div v-else-if="item.videoUrlBlob" key="player" class="text-center py-3 px-2">
                                            <video :src="item.videoUrlBlob" controls class="sa-video-player"></video>
                                        </div>
                                        <div v-else key="error" class="text-center py-4 text-danger small"><i class="fas fa-exclamation-triangle mr-1"></i> Nessun video disponibile per questo esercizio.</div>
                                    </div>
                                </b-collapse>
                            </div>
                        </div>
                    </b-collapse>
                </div>
            </template>
            <template v-else>
                <NoDataComponent ref="cmpNoDataComponentEsercizi" title="Non sono presenti esercizi prescritti" nome="no-data" subtitle="" icon="fas fa-dumbbell" />
            </template>
        </div>

        <!-- MODALS -->
        <afa-prescrizione-esercizi-modal-edit-component ref="cmpAfaPrescrioniEserciziModalEdit" :idPaziente="idPaziente" @afterSave="onAfterSave"></afa-prescrizione-esercizi-modal-edit-component>
        <afa-prescrizione-esercizio-esecuzione-modal-component ref="cmpAfaPrescrizioneEsercizioEsecuzioneModal"></afa-prescrizione-esercizio-esecuzione-modal-component>

        <!-- NUOVA MODALE: Storico Esecuzioni -->
        <b-modal id="modal-storico-esecuzioni" :title="'Storico Esecuzioni: ' + titoloEsercizioSelezionato" size="lg" hide-footer centered>
            <div v-if="isCaricamentoEsecuzioni" class="text-center py-5"><b-spinner variant="primary" class="mr-2"></b-spinner> <span>Caricamento esecuzioni in corso...</span></div>
            <div v-else>
                <b-table v-if="listaEsecuzioni.length > 0" striped hover responsive :items="listaEsecuzioni" :fields="fieldsEsecuzioni" show-empty empty-text="Nessuna esecuzione trovata per questo esercizio.">
                    <template #cell(index)="row">
                        {{ row.index + 1 }}
                    </template>
                    <template #cell(createDate)="row">
                        {{ row.item.createDate ? formatDate(row.item.createDate) : "-" }}
                    </template>
                </b-table>
                <b-alert v-else show variant="info" class="text-center mb-0">Nessuna esecuzione registrata finora per questo esercizio.</b-alert>
            </div>
        </b-modal>
    </div>
</template>

<script>
import axios from "axios";
import NoDataComponent from "../../../../../../template/components/utility/NoDataComponent.vue";
import UtilityMixin from "../../../../../utility/UtilityMixin.js";
import PrintComponent from "../../../../../utility/components/PrintComponent.vue";
import AfaPrescrizioneEserciziModalEditComponent from "./AfaPrescrizioneEserciziModalEditComponent.vue.vue";
import AfaPrescrizioneEsercizioEsecuzioneModalComponent from "./AfaPrescrizioneEsercizioEsecuzioneModalComponent.vue";

export default {
    name: "RsaPazientePrescrizioneEserciziComponent",
    mixins: [UtilityMixin],
    components: {
        NoDataComponent,
        PrintComponent,
        AfaPrescrizioneEserciziModalEditComponent,
        AfaPrescrizioneEsercizioEsecuzioneModalComponent,
    },
    data() {
        return {
            pathResource: "/pazientemedicinadellosportprescrizione",
            pathResourceEsercizi: "/pazientemedicinadellosportprescrizioneeserciziodettag",
            prescrizioniEsercizi: [],
            prescrizioniList: [],
            jsonDataAccettazione: null,
            pathresourceVideo: "/servizivideo",
            idPaziente: null,
            mostraConcluse: false,

            // Dati per la Modale Storico Esecuzioni
            listaEsecuzioni: [],
            isCaricamentoEsecuzioni: false,
            titoloEsercizioSelezionato: "",
            fieldsEsecuzioni: [
                { key: "index", label: "" },
                { key: "ripetizioniEseguite", label: "Ripetizioni", sortable: true },
                { key: "serieEseguite", label: "Serie", sortable: true },
                { key: "createDate", label: "Data", sortable: true },
                { key: "note", label: "Note", sortable: true },
                // TODO: Aggiungi qui gli altri campi che ti restituisce l'API (es: ripetizioniEffettuate, doloreAvvertito, ecc.)
            ],
        };
    },
    watch: {
        mostraConcluse() {
            this.elaboraEserciziRaggruppati();
        },
    },
    mounted() {
        this.idPaziente = this.$route.query.idPaziente ? this.$route.query.idPaziente : null;
        if (this.idPaziente) {
            this.loadPrescrizioniPaziente();
        }
    },
    methods: {
        loadPrescrizioniPaziente(jsonDataAccettazione = null) {
            if (this.jsonDataAccettazione) {
                this.jsonDataAccettazione = jsonDataAccettazione;
                this.idPaziente = this.jsonDataAccettazione.id;
            }
            this.loadPrescrizioniEserciziPaziente();
        },

        loadPrescrizioniEserciziPaziente() {
            let link = process.env.VUE_APP_PATH_API + this.pathResource;
            axios
                .get(link, { params: { idPaziente: this.idPaziente } })
                .then((response) => {
                    this.prescrizioniEsercizi = response.data.data.list;
                    this.elaboraEserciziRaggruppati();
                })
                .catch((error) => {
                    UtilityMixin.methods.messaggeBoxError(this, error);
                });
        },

        elaboraEserciziRaggruppati() {
            let listaRaggruppata = [];
            let oggi = new Date().setHours(0, 0, 0, 0);
            this.prescrizioniEsercizi.forEach((prescrizionePadre) => {
                let isScaduta = prescrizionePadre.dataFine && prescrizionePadre.dataFine < oggi;
                if (!this.mostraConcluse && (prescrizionePadre.statoAttuale === "CONCLUSA" || isScaduta)) {
                    return;
                }
                let eserciziProcessati = [];
                if (prescrizionePadre.listaEsercizi && prescrizionePadre.listaEsercizi.length > 0) {
                    eserciziProcessati = prescrizionePadre.listaEsercizi.map((esercizio) => {
                        return {
                            ...esercizio,
                            note: esercizio.note || prescrizionePadre.note,
                            quantita: esercizio.ripetizioni,
                            frequenza: esercizio.ripetizioniSettimanili,
                            posologia: esercizio.serie ? `Serie: ${esercizio.serie}` : "",
                            programmazione: `Serie: ${esercizio.serie || 0} | Rip: ${esercizio.ripetizioni || 0} | Riposo: ${esercizio.riposo || 0}s | Rip. settimanali ${esercizio.ripetizioniSettimanili || 0}`,
                            showVideo: false,
                            caricamentoVideo: false,
                            videoUrlBlob: null,
                        };
                    });
                }

                listaRaggruppata.push({
                    id: prescrizionePadre.id,
                    nome: prescrizionePadre.prescrizione || "Prescrizione",
                    dataInizio: prescrizionePadre.dataInizio,
                    dataFine: prescrizionePadre.dataFine,
                    statoAttuale: prescrizionePadre.statoAttuale || "PROGRAMMATA",
                    datiOriginali: prescrizionePadre,
                    esercizi: eserciziProcessati,
                });
            });

            this.prescrizioniList = listaRaggruppata;
        },

        onClickNuovaPrescrizioneEsercizi() {
            this.$refs.cmpAfaPrescrioniEserciziModalEdit.show(null, this.idPaziente);
        },

        onClickEditPrescrizioneEsercizi(prescrizioneDatiOriginali) {
            this.$refs.cmpAfaPrescrioniEserciziModalEdit.apriModaleConId(prescrizioneDatiOriginali.id);
        },

        concludiPrescrizione(prescrizioneOriginale) {
            let confirmed = this.$bvModal.msgBoxConfirm(`Sei sicuro di voler concludere questa prescrizione?`, {
                title: "Conferma Conclusione",
                size: "sm",
                buttonSize: "sm",
                okVariant: "success",
                okTitle: "Sì",
                cancelTitle: "No",
                footerClass: "p-2 border-top-0",
                headerClass: "border-bottom-0",
                centered: true,
            });
            if (confirmed) {
                let link = process.env.VUE_APP_PATH_API + this.pathResource + "/aggiornastato";
                let payload = {
                    ...prescrizioneOriginale,
                    statoAttuale: "CONCLUSA",
                    statoAttualeDataOra: new Date().getTime(),
                    dataFine: new Date().getTime(),
                };
                axios
                    .post(link, payload)
                    .then(() => {
                        this.loadPrescrizioniEserciziPaziente();
                    })
                    .catch((error) => {
                        UtilityMixin.methods.messaggeBoxError(this, error);
                    });
            }
        },

        onClickEseguiEsercizio(esercizio) {
            this.$refs.cmpAfaPrescrizioneEsercizioEsecuzioneModal.show(esercizio);
        },

        // NUOVA FUNZIONE: Carica le esecuzioni e apre la modale
        onClickVisualizzaEsecuzioni(esercizio) {
            this.listaEsecuzioni = [];
            this.titoloEsercizioSelezionato = this.getTestoHtmlNomeAttivita(esercizio).replace(/(<([^>]+)>)/gi, ""); // Rimuove eventuali tag HTML dal nome
            this.$bvModal.show("modal-storico-esecuzioni");
            this.loadEsecuzioniEsercizio(esercizio.id);
        },

        // NUOVA FUNZIONE: API Call per lo storico
        loadEsecuzioniEsercizio(idEsercizio) {
            let me = this;
            this.isCaricamentoEsecuzioni = true;

            this.loadDataResources(this.pathResourceEsercizi + "/" + idEsercizio, {}, me.resultResponseEsecuzioniEsercizio, me.resultErrorEsecuzioniEsercizio);
        },
        resultResponseEsecuzioniEsercizio(response) {
            let me = this;
            let esercizio = response.data.data;
            me.listaEsecuzioni = esercizio.esecuzioniEsercizi;
            this.isCaricamentoEsecuzioni = false;
        },
        resultErrorEsecuzioniEsercizio(error) {
            UtilityMixin.methods.messaggeBoxError(this, error);
            this.isCaricamentoEsecuzioni = false;
        },

        onClickVisualizzaVideo(item) {
            item.showVideo = !item.showVideo;
            if (item.showVideo && !item.videoUrlBlob && !item.caricamentoVideo) {
                if (item.idVideo) {
                    this.loadStreamVideo(item.idVideo, item);
                }
            }
        },

        loadStreamVideo(id, item) {
            item.caricamentoVideo = true;
            let link = process.env.VUE_APP_PATH_API + this.pathresourceVideo + "/video/" + id;

            axios
                .get(link, { responseType: "blob" })
                .then((response) => {
                    let urlBlob = URL.createObjectURL(response.data);
                    item.videoUrlBlob = urlBlob;
                })
                .catch((error) => {
                    console.error("Errore nel caricamento del video:", error);
                })
                .finally(() => {
                    item.caricamentoVideo = false;
                });
        },

        onAfterSave() {
            this.loadPrescrizioniEserciziPaziente();
        },

        checkStatoPaziente() {
            if (this.jsonDataAccettazione.statoAttuale === "DIMISSIONE" || this.jsonDataAccettazione.statoAttuale === "TRASFERITO" || this.jsonDataAccettazione.statoAttuale === "ASSENTE") {
                let messaggio = this.jsonDataAccettazione.statoAttuale === "DIMISSIONE" || this.jsonDataAccettazione.statoAttuale === "TRASFERITO" ? "Non è possibile questa operazione su un paziente dimesso" : "Non è possibile questa operazione su un paziente assente";

                this.$bvModal.msgBoxOk(messaggio, {
                    title: "ATTENZIONE",
                    size: "sm",
                    okVariant: "outline-danger",
                    headerClass: "sa-msg-header-danger",
                    footerClass: "p-2 border-top-0",
                    centered: true,
                });
                return false;
            }
            return true;
        },

        getTestoHtmlNomeAttivita(item) {
            return item.titolo || item.nome || item.prescrizione || "Esercizio senza nome";
        },

        getLinkPrintPrescrizione(prescrizioneDatiOriginali) {
            let id = prescrizioneDatiOriginali.idPrescrizione || prescrizioneDatiOriginali.id;
            return "/pazientemedicinadellosportprescrizione/printdata/" + id + "?idPaziente=" + this.idPaziente;
        },

        getClass(sezione, valore) {
            switch (sezione) {
                case "stato":
                case "card":
                    if (valore === "IN CORSO") {
                        return "sa-ft-badge-blue";
                    } else if (valore === "PROGRAMMATA") {
                        return "sa-ft-badge-default";
                    } else if (valore === "CONCLUSA") {
                        return "sa-ft-badge-green";
                    } else {
                        return "sa-ft-badge-red";
                    }
                default:
                    return "";
            }
        },
    },
};
</script>

<style scoped>
/* --- HEADER DELLA PRESCRIZIONE --- */
.sa-prescrizione-header {
    background-color: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    padding: 12px 15px;
    transition: background-color 0.2s ease;
}

.sa-prescrizione-header:hover {
    background-color: #f1f3f5;
}

.sa-card-list {
    display: flex;
    flex-direction: column;
    padding: 8px 0px;
}

/* La Card Moderna per gli Esercizi */
.sa-ft-modern-card {
    background: #fff;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    position: relative;
    transition: transform 0.3s cubic-bezier(0.25, 0.8, 0.25, 1), box-shadow 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
}

.sa-ft-modern-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);
    z-index: 2;
}

.sa-ft-icona-collapse {
    transition: transform 0.4s ease-in-out;
    color: #adb5bd;
}

.collapsed .sa-ft-icona-collapse {
    transform: rotate(180deg);
}

/* Tipografia */
.sa-ft-label-pai {
    font-size: 0.65rem;
    font-weight: 700;
    color: #888;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 2px;
}

.sa-ft-valore-pai {
    font-size: 0.9rem;
    color: #333;
}

.sa-ft-valore-pai.primary-text {
    color: #0056b3;
    font-weight: 600;
}

/* Container del Video */
.sa-video-container {
    background-color: #f8f9fa;
    border-radius: 0 0 8px 8px;
}

.sa-video-player {
    width: 100%;
    max-height: 400px;
    border-radius: 6px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    outline: none;
    background-color: #000;
}

/* Badge Arrotondati */
.sa-ft-badge {
    padding: 3px 10px;
    border-radius: 12px;
    font-size: 0.75rem;
    font-weight: 700;
    display: inline-block;
    border: 1px solid #dee2e6;
    max-width: fit-content;
}

.sa-ft-badge-blue {
    background-color: #e8f0fe;
    color: #1a73e8;
    border-left: 3px solid #1a73e8 !important;
    border: 1px solid #1a73e8;
}

.sa-ft-badge-default {
    background-color: #f8f9fa;
    color: #666;
    border-left: 3px solid #666 !important;
    border: 1px solid #666;
}

.sa-ft-badge-green {
    background-color: #e8f5e9;
    color: #2e7d32;
    border-left: 3px solid #2e7d32 !important;
    border: 1px solid #a5d6a7;
}

.sa-ft-badge-red {
    background-color: #fcf1f1;
    color: #b42e2ec7;
    border-left: 3px solid #b42e2ec7 !important;
    border: 1px solid #f5c2c2;
}

.ft-gap-8-px {
    gap: 8px;
}

/* --- STILI BOTTONE VIDEO --- */
.sa-video-btn {
    width: 31px !important;
    height: 31px !important;
    min-width: 31px !important;
    padding: 0 !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    background-color: transparent !important;
    color: #17a2b8 !important;
    border: 1px solid #17a2b8 !important;
    transition: transform 0.25s ease, box-shadow 0.25s ease, background-color 0.25s ease, color 0.25s ease !important;
}

.sa-video-btn:hover {
    transform: translateY(-2px) !important;
    background-color: #17a2b8 !important;
    color: #fff !important;
    box-shadow: 0 6px 12px rgba(23, 162, 184, 0.25) !important;
}

.sa-video-btn.video-open {
    background-color: #17a2b8 !important;
    color: #fff !important;
}

.sa-video-btn.video-open:hover {
    background-color: #117a8b !important;
    border-color: #117a8b !important;
    box-shadow: 0 6px 12px rgba(17, 122, 139, 0.3) !important;
}

/* Stili Bottoni Generici */
.sa-ft-floating-btn {
    width: 31px !important;
    height: 31px !important;
    min-width: 31px !important;
    padding: 0 !important;
    border-radius: 50% !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    margin-right: 0 !important;
    transition: transform 0.25s ease, box-shadow 0.25s ease, background-color 0.25s ease, color 0.25s ease !important;
}

.sa-ft-floating-btn:hover {
    transform: translateY(-2px) !important;
}

/* Overrides colori custom per bottoni bootstrap inline se necessario */
.sa-ft-floating-btn.success:hover {
    box-shadow: 0 6px 12px rgba(40, 167, 69, 0.25) !important;
}

.sa-ft-floating-btn.info:hover {
    box-shadow: 0 6px 12px rgba(23, 162, 184, 0.25) !important;
    background-color: #17a2b8 !important;
    color: white !important;
}

.sa-print-button-wrapper >>> button {
    width: 31px !important;
    height: 31px !important;
    min-width: 31px !important;
    padding: 0 !important;
    border-radius: 50% !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    margin-right: 0 !important;
    background-color: transparent !important;
    color: #6f42c1 !important;
    border: 1px solid #6f42c1 !important;
    transition: transform 0.25s ease, box-shadow 0.25s ease, background-color 0.25s ease, color 0.25s ease !important;
}

.sa-print-button-wrapper >>> button:hover {
    transform: translateY(-2px) !important;
    background-color: #6f42c1 !important;
    color: #fff !important;
    box-shadow: 0 6px 12px rgba(111, 66, 193, 0.25) !important;
}

.sa-print-button-wrapper >>> button svg {
    margin: 0 !important;
}
</style>
